export class MultiLang {
  id: number;
  nameKz: string;
  nameRu: string;
  nameEn: string;
  name: string;
  code: string;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/models/multiLang.ts